const Search = ({ onSearch }) => {
  return (
    <div className="container search-container-wrapper">
        <div className="search-container" data-sal="fade" data-sal-duration="1000">
        <input
            type="text"
            className="search-input"
            placeholder="Search"
            onChange={(e) => onSearch && onSearch(e.target.value)}
            />
        <button className="search-button">
            <i className="search-icon fa-solid fa-search"></i>
        </button>
        </div>
    </div>
  );
};

export default Search;
